(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[3576],{

/***/ 95805:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
var _instanceof = (__webpack_require__(70237)/* ["default"] */ .Z);
"client";
Object.defineProperty(exports, "__esModule", ({
    value: true
}));
exports["default"] = dynamic;
exports.noSSR = noSSR;
var _extends = (__webpack_require__(59419)/* ["default"] */ .Z);
var _interop_require_default = (__webpack_require__(23903)/* ["default"] */ .Z);
var _react = _interop_require_default(__webpack_require__(2784));
var _loadable = _interop_require_default(__webpack_require__(42060));
function dynamic(dynamicOptions, options) {
    var loadableFn = _loadable.default;
    var loadableOptions = (options == null ? void 0 : options.suspense) ? {} : {
        // A loading component is not required, so we default it
        loading: function(param) {
            var error = param.error, isLoading = param.isLoading, pastDelay = param.pastDelay;
            if (!pastDelay) return null;
            if (false) {}
            return null;
        }
    };
    // Support for direct import(), eg: dynamic(import('../hello-world'))
    // Note that this is only kept for the edge case where someone is passing in a promise as first argument
    // The react-loadable babel plugin will turn dynamic(import('../hello-world')) into dynamic(() => import('../hello-world'))
    // To make sure we don't execute the import without rendering first
    if (_instanceof(dynamicOptions, Promise)) {
        loadableOptions.loader = function() {
            return dynamicOptions;
        };
    // Support for having import as a function, eg: dynamic(() => import('../hello-world'))
    } else if (typeof dynamicOptions === "function") {
        loadableOptions.loader = dynamicOptions;
    // Support for having first argument being options, eg: dynamic({loader: import('../hello-world')})
    } else if (typeof dynamicOptions === "object") {
        loadableOptions = _extends({}, loadableOptions, dynamicOptions);
    }
    // Support for passing options, eg: dynamic(import('../hello-world'), {loading: () => <p>Loading something</p>})
    loadableOptions = _extends({}, loadableOptions, options);
    // Error if Fizz rendering is not enabled and `suspense` option is set to true
    if ( true && loadableOptions.suspense) {
        throw new Error("Invalid suspense option usage in next/dynamic. Read more: https://nextjs.org/docs/messages/invalid-dynamic-suspense");
    }
    if (loadableOptions.suspense) {
        if (false) {}
        delete loadableOptions.ssr;
        delete loadableOptions.loading;
    }
    // coming from build/babel/plugins/react-loadable-plugin.js
    if (loadableOptions.loadableGenerated) {
        loadableOptions = _extends({}, loadableOptions, loadableOptions.loadableGenerated);
        delete loadableOptions.loadableGenerated;
    }
    // support for disabling server side rendering, eg: dynamic(import('../hello-world'), {ssr: false}).
    // skip `ssr` for suspense mode and opt-in React.lazy directly
    if (typeof loadableOptions.ssr === "boolean" && !loadableOptions.suspense) {
        if (!loadableOptions.ssr) {
            delete loadableOptions.ssr;
            return noSSR(loadableFn, loadableOptions);
        }
        delete loadableOptions.ssr;
    }
    return loadableFn(loadableOptions);
}
"client";
var isServerSide = "object" === "undefined";
function noSSR(LoadableInitializer, loadableOptions) {
    // Removing webpack and modules means react-loadable won't try preloading
    delete loadableOptions.webpack;
    delete loadableOptions.modules;
    // This check is necessary to prevent react-loadable from initializing on the server
    if (!isServerSide) {
        return LoadableInitializer(loadableOptions);
    }
    var Loading = loadableOptions.loading;
    // This will only be rendered on the server side
    return function() {
        return /*#__PURE__*/ _react.default.createElement(Loading, {
            error: null,
            isLoading: true,
            pastDelay: false,
            timedOut: false
        });
    };
}
if ((typeof exports.default === "function" || typeof exports.default === "object" && exports.default !== null) && typeof exports.default.__esModule === "undefined") {
    Object.defineProperty(exports.default, "__esModule", {
        value: true
    });
    Object.assign(exports.default, exports);
    module.exports = exports.default;
} //# sourceMappingURL=dynamic.js.map


/***/ }),

/***/ 46941:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
exports.LoadableContext = void 0;
var _interop_require_default = (__webpack_require__(23903)/* ["default"] */ .Z);
var _react = _interop_require_default(__webpack_require__(2784));
var LoadableContext = _react.default.createContext(null);
exports.LoadableContext = LoadableContext;
if (false) {} //# sourceMappingURL=loadable-context.js.map


/***/ }),

/***/ 42060:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
var _classCallCheck = (__webpack_require__(60616)/* ["default"] */ .Z);
var _createClass = (__webpack_require__(90416)/* ["default"] */ .Z);
Object.defineProperty(exports, "__esModule", ({
    value: true
}));
exports["default"] = void 0;
var _extends = (__webpack_require__(59419)/* ["default"] */ .Z);
var _interop_require_default = (__webpack_require__(23903)/* ["default"] */ .Z);
var _react = _interop_require_default(__webpack_require__(2784));
var _loadableContext = __webpack_require__(46941);
var useSyncExternalStore = ( false ? 0 : __webpack_require__(43100)).useSyncExternalStore;
var ALL_INITIALIZERS = [];
var READY_INITIALIZERS = [];
var initialized = false;
function load(loader) {
    var promise = loader();
    var state = {
        loading: true,
        loaded: null,
        error: null
    };
    state.promise = promise.then(function(loaded) {
        state.loading = false;
        state.loaded = loaded;
        return loaded;
    }).catch(function(err) {
        state.loading = false;
        state.error = err;
        throw err;
    });
    return state;
}
function resolve(obj) {
    return obj && obj.__esModule ? obj.default : obj;
}
function createLoadableComponent(loadFn, options) {
    var init = function init() {
        if (!subscription) {
            var sub = new LoadableSubscription(loadFn, opts);
            subscription = {
                getCurrentValue: sub.getCurrentValue.bind(sub),
                subscribe: sub.subscribe.bind(sub),
                retry: sub.retry.bind(sub),
                promise: sub.promise.bind(sub)
            };
        }
        return subscription.promise();
    };
    var useLoadableModule = function useLoadableModule() {
        init();
        var context = _react.default.useContext(_loadableContext.LoadableContext);
        if (context && Array.isArray(opts.modules)) {
            opts.modules.forEach(function(moduleName) {
                context(moduleName);
            });
        }
    };
    var LoadableImpl = function LoadableImpl(props, ref) {
        useLoadableModule();
        var state = useSyncExternalStore(subscription.subscribe, subscription.getCurrentValue, subscription.getCurrentValue);
        _react.default.useImperativeHandle(ref, function() {
            return {
                retry: subscription.retry
            };
        }, []);
        return _react.default.useMemo(function() {
            if (state.loading || state.error) {
                return _react.default.createElement(opts.loading, {
                    isLoading: state.loading,
                    pastDelay: state.pastDelay,
                    timedOut: state.timedOut,
                    error: state.error,
                    retry: subscription.retry
                });
            } else if (state.loaded) {
                return _react.default.createElement(resolve(state.loaded), props);
            } else {
                return null;
            }
        }, [
            props,
            state
        ]);
    };
    var LazyImpl = function LazyImpl(props, ref) {
        useLoadableModule();
        return _react.default.createElement(opts.lazy, _extends({}, props, {
            ref: ref
        }));
    };
    var opts = Object.assign({
        loader: null,
        loading: null,
        delay: 200,
        timeout: null,
        webpack: null,
        modules: null,
        suspense: false
    }, options);
    if (opts.suspense) {
        opts.lazy = _react.default.lazy(opts.loader);
    }
    /** @type LoadableSubscription */ var subscription = null;
    // Server only
    if (false) {}
    // Client only
    if (!initialized && "object" !== "undefined") {
        // require.resolveWeak check is needed for environments that don't have it available like Jest
        var moduleIds = opts.webpack && "function" === "function" ? opts.webpack() : opts.modules;
        if (moduleIds) {
            READY_INITIALIZERS.push(function(ids) {
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                try {
                    for(var _iterator = moduleIds[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                        var moduleId = _step.value;
                        if (ids.indexOf(moduleId) !== -1) {
                            return init();
                        }
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                            _iterator.return();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
            });
        }
    }
    var LoadableComponent = opts.suspense ? LazyImpl : LoadableImpl;
    LoadableComponent.preload = function() {
        return init();
    };
    LoadableComponent.displayName = "LoadableComponent";
    return _react.default.forwardRef(LoadableComponent);
}
var LoadableSubscription = /*#__PURE__*/ function() {
    function LoadableSubscription(loadFn, opts) {
        _classCallCheck(this, LoadableSubscription);
        this._loadFn = loadFn;
        this._opts = opts;
        this._callbacks = new Set();
        this._delay = null;
        this._timeout = null;
        this.retry();
    }
    _createClass(LoadableSubscription, [
        {
            key: "promise",
            value: function promise() {
                return this._res.promise;
            }
        },
        {
            key: "retry",
            value: function retry() {
                var _this = this;
                this._clearTimeouts();
                this._res = this._loadFn(this._opts.loader);
                this._state = {
                    pastDelay: false,
                    timedOut: false
                };
                var ref = this, res = ref._res, opts = ref._opts;
                if (res.loading) {
                    if (typeof opts.delay === "number") {
                        if (opts.delay === 0) {
                            this._state.pastDelay = true;
                        } else {
                            this._delay = setTimeout(function() {
                                _this._update({
                                    pastDelay: true
                                });
                            }, opts.delay);
                        }
                    }
                    if (typeof opts.timeout === "number") {
                        this._timeout = setTimeout(function() {
                            _this._update({
                                timedOut: true
                            });
                        }, opts.timeout);
                    }
                }
                this._res.promise.then(function() {
                    _this._update({});
                    _this._clearTimeouts();
                }).catch(function(_err) {
                    _this._update({});
                    _this._clearTimeouts();
                });
                this._update({});
            }
        },
        {
            key: "_update",
            value: function _update(partial) {
                this._state = _extends({}, this._state, {
                    error: this._res.error,
                    loaded: this._res.loaded,
                    loading: this._res.loading
                }, partial);
                this._callbacks.forEach(function(callback) {
                    return callback();
                });
            }
        },
        {
            key: "_clearTimeouts",
            value: function _clearTimeouts() {
                clearTimeout(this._delay);
                clearTimeout(this._timeout);
            }
        },
        {
            key: "getCurrentValue",
            value: function getCurrentValue() {
                return this._state;
            }
        },
        {
            key: "subscribe",
            value: function subscribe(callback) {
                var _this = this;
                this._callbacks.add(callback);
                return function() {
                    _this._callbacks.delete(callback);
                };
            }
        }
    ]);
    return LoadableSubscription;
}();
function Loadable(opts) {
    return createLoadableComponent(load, opts);
}
function flushInitializers(initializers, ids) {
    var promises = [];
    while(initializers.length){
        var init = initializers.pop();
        promises.push(init(ids));
    }
    return Promise.all(promises).then(function() {
        if (initializers.length) {
            return flushInitializers(initializers, ids);
        }
    });
}
Loadable.preloadAll = function() {
    return new Promise(function(resolveInitializers, reject) {
        flushInitializers(ALL_INITIALIZERS).then(resolveInitializers, reject);
    });
};
Loadable.preloadReady = function() {
    var ids = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : [];
    return new Promise(function(resolvePreload) {
        var res = function() {
            initialized = true;
            return resolvePreload();
        };
        // We always will resolve, errors should be handled within loading UIs.
        flushInitializers(READY_INITIALIZERS, ids).then(res, res);
    });
};
if (true) {
    window.__NEXT_PRELOADREADY = Loadable.preloadReady;
}
var _default = Loadable;
exports["default"] = _default; //# sourceMappingURL=loadable.js.map


/***/ }),

/***/ 58447:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ blog_BlogComponent; }
});

// EXTERNAL MODULE: ../../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(52322);
// EXTERNAL MODULE: ./components/layout/Page.tsx + 19 modules
var Page = __webpack_require__(24882);
// EXTERNAL MODULE: ./components/marketingSite/blog/cards/BlogCard.tsx + 1 modules
var BlogCard = __webpack_require__(12032);
// EXTERNAL MODULE: ./components/marketingSite/blog/layout/BlogCta.tsx
var BlogCta = __webpack_require__(99812);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_to_consumable_array.mjs + 2 modules
var _to_consumable_array = __webpack_require__(50930);
// EXTERNAL MODULE: ../../node_modules/@fortawesome/pro-light-svg-icons/index.mjs
var pro_light_svg_icons = __webpack_require__(38914);
// EXTERNAL MODULE: ../../node_modules/@fortawesome/react-fontawesome/index.es.js
var index_es = __webpack_require__(49929);
// EXTERNAL MODULE: ../../node_modules/next/dist/client/router.js
var router = __webpack_require__(93642);
// EXTERNAL MODULE: ../../node_modules/next/link.js
var next_link = __webpack_require__(39097);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ./utils/app-urls.ts
var app_urls = __webpack_require__(62177);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(92228);
// EXTERNAL MODULE: ../../node_modules/styled-components/dist/styled-components.browser.esm.js + 1 modules
var styled_components_browser_esm = __webpack_require__(40286);
// EXTERNAL MODULE: ./theme/index.js + 247 modules
var theme = __webpack_require__(90408);
// EXTERNAL MODULE: ./components/shared/ButtonLink.styled.tsx
var ButtonLink_styled = __webpack_require__(8536);
;// CONCATENATED MODULE: ./components/marketingSite/blog/layout/BlogPagination.styled.tsx

function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  justify-content: center;\n  gap: ",
        ";\n  padding-top: ",
        ";\n  padding-bottom: 0;\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n\n  @media (max-width: ",
        ") {\n    display: none;\n  }\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  border-radius: 0;\n  border: none;\n  border-bottom: 2px solid\n    ",
        ";\n\n  font-weight: ",
        ";\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}



var StyledPagination = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-42a7bcee-0"
})(_templateObject(), (0,theme/* spacing */.W0)("xs"), (0,theme/* spacing */.W0)("xl3"));
var StyledEllipsis = styled_components_browser_esm/* default.span.withConfig */.ZP.span.withConfig({
    componentId: "sc-42a7bcee-1"
})(_templateObject1(), (0,theme/* screen */.sp)("mdMax"));
var StyledButtonLink = (0,styled_components_browser_esm/* default */.ZP)(ButtonLink_styled/* default */.C).withConfig({
    componentId: "sc-42a7bcee-2"
})(_templateObject2(), function(param) {
    var $isActive = param.$isActive;
    return $isActive ? (0,theme/* color */.$_)("emerald_500") : "transparent";
}, (0,theme/* fontWeight */.Ue)("medium"));

;// CONCATENATED MODULE: ./components/marketingSite/blog/layout/BlogPagination.tsx









var ellipsis = /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledEllipsis, {
    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* FontAwesomeIcon */.G, {
        icon: pro_light_svg_icons/* faEllipsis */.S6C
    })
});
var BlogPagination = function(param) {
    var totalPages = param.totalPages, currentPage = param.currentPage, category = param.category;
    var locale = (0,router.useRouter)().locale;
    var pages = totalPages || 0;
    var page = currentPage || 1;
    var pagerPrefix = category ? "".concat((0,app_urls/* getAppUrl */.TI)(app_urls/* APP_URLS.blog */.uu.blog, locale), "/category/").concat(category, "/page/") : "".concat((0,app_urls/* getAppUrl */.TI)(app_urls/* APP_URLS.blog */.uu.blog, locale), "/page/");
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledPagination, {
        children: [
            pages > 1 && page > 1 && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                        href: "".concat(pagerPrefix, "1"),
                        passHref: true,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledButtonLink, {
                            sizes: "sm",
                            variant: "secondary",
                            isIcon: true,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* FontAwesomeIcon */.G, {
                                icon: pro_light_svg_icons/* faArrowToLeft */.s87
                            })
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                        href: "".concat(pagerPrefix).concat(page - 1),
                        passHref: true,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledButtonLink, {
                            sizes: "sm",
                            variant: "secondary",
                            isIcon: true,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* FontAwesomeIcon */.G, {
                                icon: pro_light_svg_icons/* faArrowLeft */.acZ
                            })
                        })
                    })
                ]
            }),
            page - 2 > 0 && ellipsis,
            (0,_to_consumable_array/* default */.Z)(Array(pages)).map(function(p, i) {
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(react.Fragment, {
                    children: i + 1 >= page - 1 && i + 1 <= page + 1 && /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                        href: "".concat(pagerPrefix).concat(i + 1),
                        passHref: true,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledButtonLink, {
                            sizes: "sm",
                            variant: "secondary",
                            isIcon: true,
                            className: "number",
                            $isActive: page === i + 1,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                children: String(i + 1).padStart(2, "0")
                            })
                        })
                    })
                }, "".concat(pagerPrefix).concat(i + 1));
            }),
            page + 2 <= pages && ellipsis,
            pages > 1 && page < pages && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                        href: "".concat(pagerPrefix).concat(page + 1),
                        passHref: true,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledButtonLink, {
                            sizes: "sm",
                            variant: "secondary",
                            isIcon: true,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* FontAwesomeIcon */.G, {
                                icon: pro_light_svg_icons/* faArrowRight */.eFW
                            })
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                        href: "".concat(pagerPrefix).concat(pages),
                        passHref: true,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledButtonLink, {
                            sizes: "sm",
                            variant: "secondary",
                            isIcon: true,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* FontAwesomeIcon */.G, {
                                icon: pro_light_svg_icons/* faArrowToRight */._Iw
                            })
                        })
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var layout_BlogPagination = (BlogPagination);

// EXTERNAL MODULE: ./components/shared/Typography.js
var Typography = __webpack_require__(99655);
// EXTERNAL MODULE: ./hooks/useI18n/index.ts + 1 modules
var useI18n = __webpack_require__(39105);
// EXTERNAL MODULE: ./components/marketingSite/shared/Cta.styled.tsx
var Cta_styled = __webpack_require__(7425);
;// CONCATENATED MODULE: ./components/marketingSite/blog/BlogComponent.styled.ts

function BlogComponent_styled_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: ",
        ";\n  padding: ",
        " ",
        ";\n  margin: 0;\n  text-align: center;\n  background-color: ",
        ";\n\n  > * {\n    max-width: ",
        ";\n    margin: auto;\n    width: 100%;\n  }\n  > ",
        " {\n    max-width: ",
        ";\n  }\n"
    ]);
    BlogComponent_styled_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function BlogComponent_styled_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  text-align: center;\n  font-size: ",
        ";\n"
    ]);
    BlogComponent_styled_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function BlogComponent_styled_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  border-top: 1px solid ",
        ";\n  border-bottom: 1px solid ",
        ";\n  padding-top: ",
        ";\n  padding-bottom: ",
        ";\n  display: inline-flex;\n  flex-wrap: wrap;\n  justify-content: center;\n  gap: ",
        "; /* \n  margin-bottom: ",
        "; */\n"
    ]);
    BlogComponent_styled_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: grid;\n  grid-template-columns: 1fr;\n  gap: ",
        ";\n  width: 100%; // use full width of StyledBlog\n\n  @media (min-width: ",
        ") {\n    grid-template-columns: repeat(2, 1fr);\n  }\n  @media (min-width: ",
        ") {\n    grid-template-columns: repeat(3, 1fr);\n  }\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  flex-direction: column;\n  border-radius: ",
        ";\n  background-color: ",
        ";\n  margin-bottom: ",
        ";\n  padding: ",
        ";\n  color: ",
        ";\n  gap: ",
        ";\n  box-shadow: 8px 8px 32px rgba(44, 62, 80, 0.1);\n  &:hover {\n    box-shadow: rgb(255, 255, 255) 0px 0px 0px 12px,\n      rgba(38, 26, 25, 0.04) 0px 1.51px 5.3px 12px,\n      rgba(38, 26, 25, 0.05) 0px 3.03px 4.54px 12px;\n    transition: box-shadow 0.3s ease-in-out;\n  }\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}



var StyledBlog = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-1a773b79-0"
})(BlogComponent_styled_templateObject(), (0,theme/* spacing */.W0)("lg"), (0,theme/* spacing */.W0)("xl4"), (0,theme/* spacing */.W0)("md"), (0,theme/* color */.$_)("midnight_100"), (0,theme/* container */.nC)("xl"), Cta_styled/* StyledCta */.B, (0,theme/* container */.nC)("md"));
var StyledBlogHeader = styled_components_browser_esm/* default.header.withConfig */.ZP.header.withConfig({
    componentId: "sc-1a773b79-1"
})(BlogComponent_styled_templateObject1(), (0,theme/* fontSize */.JB)("lg"));
var StyledTags = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-1a773b79-2"
})(BlogComponent_styled_templateObject2(), (0,theme/* color */.$_)("midnight_200"), (0,theme/* color */.$_)("midnight_200"), (0,theme/* spacing */.W0)("md"), (0,theme/* spacing */.W0)("md"), (0,theme/* spacing */.W0)("xs"), (0,theme/* spacing */.W0)("xl3"));
var StyledBlogCards = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-1a773b79-3"
})(_templateObject3(), (0,theme/* spacing */.W0)("lg"), (0,theme/* screen */.sp)("md"), (0,theme/* screen */.sp)("lg"));
var StyledBlogSpotlightCards = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-1a773b79-4"
})(_templateObject4(), (0,theme/* radius */.q0)("lg"), (0,theme/* color */.$_)("white"), (0,theme/* spacing */.W0)("xl"), (0,theme/* spacing */.W0)("lg"), (0,theme/* color */.$_)("emerald_750"), (0,theme/* spacing */.W0)("lg"));

// EXTERNAL MODULE: ../ui-library/dist/index.js + 203 modules
var dist = __webpack_require__(78197);
// EXTERNAL MODULE: ./components/marketingSite/blog/cards/CategoryBadge.tsx
var CategoryBadge = __webpack_require__(47970);
// EXTERNAL MODULE: ./components/marketingSite/blog/cards/CategoryBadge.styled.tsx
var CategoryBadge_styled = __webpack_require__(54807);
;// CONCATENATED MODULE: ./components/marketingSite/blog/cards/BlogSpotlightCard.styled.tsx

function BlogSpotlightCard_styled_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  flex-direction: row;\n  align-items: stretch;\n  text-decoration: none;\n  border-radius: ",
        ";\n  background-color: ",
        ";\n  color: ",
        ";\n  transition: 0.3s ease;\n  gap: ",
        ";\n\n  &:hover {\n    color: ",
        ";\n  }\n\n  @media (max-width: ",
        ") {\n    flex-direction: column;\n    align-items: center;\n    text-align: center;\n  }\n"
    ]);
    BlogSpotlightCard_styled_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function BlogSpotlightCard_styled_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  flex: 1 1 50%;\n  position: relative;\n  aspect-ratio: 4 / 3;\n  overflow: hidden;\n  border-radius: ",
        ";\n  display: flex;\n  align-items: center;\n  justify-content: center;\n\n  img {\n    width: 100%;\n    height: 100%;\n    object-fit: cover;\n\n    mask-image: url('/images/blog/irregular-box-white.svg');\n    mask-size: 100% 100%;\n    mask-repeat: no-repeat;\n    mask-position: center;\n\n    -webkit-mask-image: url('/images/blog/irregular-box-white.svg');\n    -webkit-mask-size: 100% 100%;\n    -webkit-mask-repeat: no-repeat;\n    -webkit-mask-position: center;\n  }\n\n  @media (max-width: ",
        ") {\n    width: 100%;\n    flex: unset;\n    aspect-ratio: auto;\n    border-radius: ",
        ";\n  }\n"
    ]);
    BlogSpotlightCard_styled_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function BlogSpotlightCard_styled_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: 100%;\n  height: 100%;\n  background-image: linear-gradient(\n    47deg,\n    ",
        ",\n    ",
        " 70%\n  );\n  display: flex;\n  align-items: center;\n  justify-content: center;\n\n  img {\n    height: auto;\n    max-height: 60%;\n  }\n"
    ]);
    BlogSpotlightCard_styled_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function BlogSpotlightCard_styled_templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  flex: 1 1 50%;\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  gap: ",
        ";\n  text-align: left;\n\n  @media (max-width: ",
        ") {\n    width: 100%;\n    flex: unset;\n    align-items: center;\n    text-align: center;\n  }\n"
    ]);
    BlogSpotlightCard_styled_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function BlogSpotlightCard_styled_templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: inline-flex;\n  align-items: end;\n  gap: ",
        ";\n\n  font-size: ",
        ";\n  line-height: 1;\n  color: ",
        ";\n  margin: 0 0 ",
        " 0;\n\n  @media (max-width: ",
        ") {\n    text-align: center;\n  }\n"
    ]);
    BlogSpotlightCard_styled_templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  font-size: ",
        ";\n  font-weight: ",
        ";\n  margin: 0;\n  color: ",
        ";\n"
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function _templateObject6() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  p:first-child {\n    margin-top: 0;\n  }\n\n  p:last-child {\n    margin-bottom: 0;\n  }\n"
    ]);
    _templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function _templateObject7() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  && {\n    justify-content: flex-start;\n  }\n"
    ]);
    _templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}



var StyledCard = styled_components_browser_esm/* default.a.withConfig */.ZP.a.withConfig({
    componentId: "sc-375f8bbc-0"
})(BlogSpotlightCard_styled_templateObject(), (0,theme/* radius */.q0)("lg"), (0,theme/* color */.$_)("white"), (0,theme/* color */.$_)("emerald_750"), (0,theme/* spacing */.W0)("lg"), (0,theme/* color */.$_)("emerald_750"), (0,theme/* screen */.sp)("md"));
var StyledThumb = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-375f8bbc-1"
})(BlogSpotlightCard_styled_templateObject1(), (0,theme/* radius */.q0)("md"), (0,theme/* screen */.sp)("sm"), (0,theme/* radius */.q0)("md"));
var StyledEmptyThumb = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-375f8bbc-2"
})(BlogSpotlightCard_styled_templateObject2(), (0,theme/* color */.$_)("purple_700"), (0,theme/* color */.$_)("mint_900"));
var StyledContent = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-375f8bbc-3"
})(BlogSpotlightCard_styled_templateObject3(), (0,theme/* spacing */.W0)("xs"), (0,theme/* screen */.sp)("sm"));
var StyledDate = styled_components_browser_esm/* default.p.withConfig */.ZP.p.withConfig({
    componentId: "sc-375f8bbc-4"
})(BlogSpotlightCard_styled_templateObject4(), (0,theme/* spacing */.W0)("xs"), (0,theme/* fontSize */.JB)("sm"), (0,theme/* color */.$_)("emerald_750"), (0,theme/* spacing */.W0)("xs"), (0,theme/* screen */.sp)("sm"));
var StyledTitle = styled_components_browser_esm/* default.h2.withConfig */.ZP.h2.withConfig({
    componentId: "sc-375f8bbc-5"
})(_templateObject5(), (0,theme/* fontSize */.JB)("lg"), (0,theme/* fontWeight */.Ue)("bold"), (0,theme/* color */.$_)("mint_800"));
var StyledExcerpt = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-375f8bbc-6"
})(_templateObject6());
var StyledTagsFix = (0,styled_components_browser_esm/* default */.ZP)(CategoryBadge_styled/* StyledBadges */._d).withConfig({
    componentId: "sc-375f8bbc-7"
})(_templateObject7());

// EXTERNAL MODULE: ./utils/localize.utils.ts
var localize_utils = __webpack_require__(38062);
;// CONCATENATED MODULE: ./components/marketingSite/blog/cards/BlogSpotlightCard.tsx










var BlogSpotlightCard = function(param) {
    var post = param.post, url = param.url, title = param.title, thumb = param.thumb, date = param.date, _excerpt = param.excerpt, excerpt = _excerpt === void 0 ? "" : _excerpt, _allTags = param.allTags, allTags = _allTags === void 0 ? [] : _allTags;
    var locale = (0,router.useRouter)().locale;
    var postTagNames = (0,react.useMemo)(function() {
        if (!Array.isArray(post.tags)) return [];
        return post.tags.map(function(tagId) {
            var ref;
            return (ref = allTags.find(function(tag) {
                return tag.id === tagId;
            })) === null || ref === void 0 ? void 0 : ref.name;
        }).filter(function(name) {
            return Boolean(name);
        }).map(function(name) {
            return (0,localize_utils/* toTitleCase */.L)(name);
        }).sort(function(a, b) {
            return a.localeCompare(b);
        });
    }, [
        post.tags,
        allTags
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
        href: "".concat((0,app_urls/* getAppUrl */.TI)(app_urls/* APP_URLS.blog */.uu.blog, locale), "/").concat(url),
        passHref: true,
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledCard, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
                    width: "0",
                    height: "0",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("defs", {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("clipPath", {
                            id: "blogThumbClip",
                            clipPathUnits: "objectBoundingBox",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                d: "..."
                            })
                        })
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledThumb, {
                    children: thumb && /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                        src: thumb,
                        alt: ""
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledContent, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledDate, {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(dist/* Icon */.JO, {
                                    icon: pro_light_svg_icons/* faCalendar */.fT7
                                }),
                                new Date(date).toLocaleDateString(locale, {
                                    year: "numeric",
                                    month: "numeric",
                                    day: "numeric"
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledTitle, {
                            children: title
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledExcerpt, {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                dangerouslySetInnerHTML: {
                                    __html: excerpt
                                }
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledTagsFix, {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CategoryBadge/* CategoryBadge */.E, {
                                tagList: postTagNames
                            })
                        })
                    ]
                })
            ]
        })
    });
};
/* harmony default export */ var cards_BlogSpotlightCard = (BlogSpotlightCard);

// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_define_property.mjs
var _define_property = __webpack_require__(47842);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(70865);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(96670);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_sliced_to_array.mjs + 2 modules
var _sliced_to_array = __webpack_require__(66383);
;// CONCATENATED MODULE: ./components/marketingSite/blog/categories/BlogCategoryFilter.styled.tsx

function BlogCategoryFilter_styled_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  align-items: center;\n  justify-content: center;\n"
    ]);
    BlogCategoryFilter_styled_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function BlogCategoryFilter_styled_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: none;\n\n  @media (min-width: ",
        ") {\n    display: flex;\n    justify-content: center;\n    padding: 0;\n    white-space: nowrap;\n    max-height: ",
        ";\n  }\n"
    ]);
    BlogCategoryFilter_styled_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function BlogCategoryFilter_styled_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  justify-content: center;\n  gap: ",
        ";\n  padding: ",
        " ",
        ";\n\n  border-bottom: 2px solid\n    ",
        ";\n  z-index: 2;\n"
    ]);
    BlogCategoryFilter_styled_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function BlogCategoryFilter_styled_templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  gap: ",
        ";\n\n  font-weight: ",
        ";\n  font-size: ",
        ";\n  text-decoration: none;\n  color: ",
        ";\n\n  &:hover {\n    color: ",
        ";\n  }\n  &:focus,\n  &:focus-visible {\n    color: unset;\n    outline: 3px solid ",
        ";\n    outline-offset: 8px;\n    transition: none;\n  }\n\n  span.count {\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    width: 22px;\n    height: 22px;\n    min-width: 22px;\n    min-height: 22px;\n    flex-shrink: 0;\n    border-radius: ",
        ";\n    border: 2px solid;\n    border-color: ",
        ";\n    font-size: 8px;\n    font-weight: ",
        ";\n    text-align: center;\n    background: ",
        ";\n    color: ",
        ";\n  }\n"
    ]);
    BlogCategoryFilter_styled_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function BlogCategoryFilter_styled_templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  width: 16px;\n  height: 16px;\n  vertical-align: middle;\n\n  svg,\n  img {\n    width: 100%;\n    height: 100%;\n    display: block;\n    object-fit: contain;\n  }\n"
    ]);
    BlogCategoryFilter_styled_templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function BlogCategoryFilter_styled_templateObject5() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  align-items: center;\n  max-width: ",
        ";\n  gap: ",
        ";\n  margin: ",
        " 0;\n\n  @media (min-width: ",
        ") {\n    display: none !important;\n  }\n"
    ]);
    BlogCategoryFilter_styled_templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}



var CategorySection = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-feadc4f0-0"
})(BlogCategoryFilter_styled_templateObject());
var BlogCategoryFilter_styled_StyledTags = styled_components_browser_esm/* default.nav.withConfig */.ZP.nav.withConfig({
    componentId: "sc-feadc4f0-1"
})(BlogCategoryFilter_styled_templateObject1(), (0,theme/* screen */.sp)("lg"), (0,theme/* spacing */.W0)("xl3"));
var StyledTabElement = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-feadc4f0-2"
})(BlogCategoryFilter_styled_templateObject2(), (0,theme/* spacing */.W0)("xs2"), (0,theme/* spacing */.W0)("xs"), (0,theme/* spacing */.W0)("sm"), function(param) {
    var active = param.active;
    return active ? (0,theme/* color */.$_)("emerald_500") : (0,theme/* color */.$_)("midnight_200");
});
var TabLink = styled_components_browser_esm/* default.a.withConfig */.ZP.a.withConfig({
    componentId: "sc-feadc4f0-3"
})(BlogCategoryFilter_styled_templateObject3(), (0,theme/* spacing */.W0)("xs"), (0,theme/* fontWeight */.Ue)("semiBold"), (0,theme/* fontSize */.JB)("md"), function(param) {
    var active = param.active;
    return active ? (0,theme/* color */.$_)("emerald_500") : (0,theme/* color */.$_)("midnight_600");
}, (0,theme/* color */.$_)("midnight_400"), (0,theme/* color */.$_)("emerald_250"), (0,theme/* radius */.q0)("full"), function(param) {
    var active = param.active;
    return active ? (0,theme/* color */.$_)("emerald") : (0,theme/* color */.$_)("info_250");
}, (0,theme/* fontWeight */.Ue)("black"), function(param) {
    var active = param.active;
    return active ? (0,theme/* color */.$_)("emerald_100") : (0,theme/* color */.$_)("info_50");
}, function(param) {
    var active = param.active;
    return active ? (0,theme/* color */.$_)("emerald_500") : (0,theme/* color */.$_)("info_600");
});
var CategoryIconSlot = styled_components_browser_esm/* default.span.withConfig */.ZP.span.withConfig({
    componentId: "sc-feadc4f0-4"
})(BlogCategoryFilter_styled_templateObject4());
var MobileButton = (0,styled_components_browser_esm/* default */.ZP)(dist/* Button */.zx).withConfig({
    componentId: "sc-feadc4f0-5"
})(BlogCategoryFilter_styled_templateObject5(), (0,theme/* container */.nC)("xs2"), (0,theme/* spacing */.W0)("xs"), (0,theme/* spacing */.W0)("sm"), (0,theme/* screen */.sp)("lg"));

// EXTERNAL MODULE: ./utils/paths.tsx
var paths = __webpack_require__(64516);
// EXTERNAL MODULE: ../../node_modules/@fortawesome/pro-solid-svg-icons/index.mjs
var pro_solid_svg_icons = __webpack_require__(54933);
// EXTERNAL MODULE: ../../node_modules/next/router.js
var next_router = __webpack_require__(5632);
;// CONCATENATED MODULE: ./components/marketingSite/blog/categories/CategoryDrawer.styled.tsx

function CategoryDrawer_styled_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  flex-direction: column;\n  gap: ",
        ";\n  padding: ",
        ";\n  top: ",
        ";\n  position: relative;\n"
    ]);
    CategoryDrawer_styled_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function CategoryDrawer_styled_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  position: fixed;\n  inset: 0;\n  background: rgba(0, 0, 0, 0.25);\n  z-index: 1000;\n  display: flex;\n  flex-direction: column;\n  gap: ",
        ";\n  padding: ",
        ";\n  top: ",
        ";\n"
    ]);
    CategoryDrawer_styled_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function CategoryDrawer_styled_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  position: absolute;\n  top: 0;\n  right: 0;\n  width: 300px;\n  height: 100%;\n  background: #ffffff;\n  padding: 1rem;\n  overflow-y: auto;\n"
    ]);
    CategoryDrawer_styled_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function CategoryDrawer_styled_templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin-bottom: 1rem;\n"
    ]);
    CategoryDrawer_styled_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function CategoryDrawer_styled_templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  margin: 0;\n  font-size: 1.5rem;\n  font-weight: 700;\n  color: #273043;\n"
    ]);
    CategoryDrawer_styled_templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function CategoryDrawer_styled_templateObject5() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  background: none;\n  border: none;\n  font-size: 1.75rem;\n  line-height: 1;\n  cursor: pointer;\n  color: #273043;\n"
    ]);
    CategoryDrawer_styled_templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function CategoryDrawer_styled_templateObject6() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  align-items: center;\n  gap: 0.4rem;\n  width: 100%;\n  padding: 0.55rem 0.9rem;\n  border: 2px solid #d7dfe7;\n  border-radius: 8px;\n  background: transparent;\n  font-weight: 600;\n  color: #273043;\n  cursor: pointer;\n  margin-bottom: 1rem;\n\n  svg {\n    flex-shrink: 0;\n  }\n"
    ]);
    CategoryDrawer_styled_templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function CategoryDrawer_styled_templateObject7() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  border: 2px solid #d7dfe7;\n  border-radius: 8px;\n  overflow: hidden;\n  margin-top: ",
        ";\n"
    ]);
    CategoryDrawer_styled_templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}
function _templateObject8() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  border-bottom: 2px solid ",
        ";\n\n  &:last-child {\n    border-bottom: none;\n  }\n"
    ]);
    _templateObject8 = function _templateObject8() {
        return data;
    };
    return data;
}
function _templateObject9() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  align-items: center;\n  padding: 0.75rem 1rem;\n  font-size: ",
        ";\n  font-weight: ",
        ";\n  color: ",
        " !important;\n  text-align: left;\n  text-decoration: none;\n\n  &:hover {\n    background-color: ",
        ";\n    color: ",
        ";\n  }\n  &:hover a {\n    color: ",
        ";\n  }\n"
    ]);
    _templateObject9 = function _templateObject9() {
        return data;
    };
    return data;
}
function _templateObject10() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  flex: 1;\n  text-decoration: none;\n  color: inherit;\n"
    ]);
    _templateObject10 = function _templateObject10() {
        return data;
    };
    return data;
}
function _templateObject11() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  background: transparent;\n  border: none;\n  display: flex;\n  align-items: center;\n  cursor: pointer;\n  &:hover {\n    color: ",
        ";\n  }\n"
    ]);
    _templateObject11 = function _templateObject11() {
        return data;
    };
    return data;
}
function _templateObject12() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  list-style: none;\n  margin: 0;\n  padding: 0;\n  background-color: ",
        ";\n"
    ]);
    _templateObject12 = function _templateObject12() {
        return data;
    };
    return data;
}
function _templateObject13() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: block;\n  width: 100%;\n  padding: 0.55rem 1.25rem;\n  border-bottom: 2px solid ",
        ";\n  text-align: left;\n  text-decoration: none;\n  color: #273043;\n  cursor: pointer;\n\n  &:hover {\n    background-color: ",
        ";\n    color: ",
        ";\n  }\n\n  &:last-child {\n    border-bottom: none;\n  }\n"
    ]);
    _templateObject13 = function _templateObject13() {
        return data;
    };
    return data;
}


var StyledDrawerContent = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-fe88f347-0"
})(CategoryDrawer_styled_templateObject(), (0,theme/* spacing */.W0)("sm"), (0,theme/* spacing */.W0)("md"), (0,theme/* spacing */.W0)("xl4"));
var Backdrop = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-fe88f347-1"
})(CategoryDrawer_styled_templateObject1(), (0,theme/* spacing */.W0)("sm"), (0,theme/* spacing */.W0)("md"), (0,theme/* spacing */.W0)("xl4"));
var Drawer = styled_components_browser_esm/* default.aside.withConfig */.ZP.aside.withConfig({
    componentId: "sc-fe88f347-2"
})(CategoryDrawer_styled_templateObject2());
var Header = styled_components_browser_esm/* default.header.withConfig */.ZP.header.withConfig({
    componentId: "sc-fe88f347-3"
})(CategoryDrawer_styled_templateObject3());
var Title = styled_components_browser_esm/* default.h2.withConfig */.ZP.h2.withConfig({
    componentId: "sc-fe88f347-4"
})(CategoryDrawer_styled_templateObject4());
var CloseBtn = styled_components_browser_esm/* default.button.withConfig */.ZP.button.withConfig({
    componentId: "sc-fe88f347-5"
})(CategoryDrawer_styled_templateObject5());
var HomeBtn = styled_components_browser_esm/* default.button.withConfig */.ZP.button.withConfig({
    componentId: "sc-fe88f347-6"
})(CategoryDrawer_styled_templateObject6());
var Accordion = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-fe88f347-7"
})(CategoryDrawer_styled_templateObject7(), (0,theme/* spacing */.W0)("lg"));
var CategoryBlock = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-fe88f347-8"
})(_templateObject8(), (0,theme/* color */.$_)("midnight_200"));
var CategoryHeader = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-fe88f347-9"
})(_templateObject9(), (0,theme/* fontSize */.JB)("md"), (0,theme/* fontWeight */.Ue)("bold"), (0,theme/* color */.$_)("black"), (0,theme/* color */.$_)("emerald_500"), (0,theme/* color */.$_)("white"), (0,theme/* color */.$_)("white"));
var CategoryLink = styled_components_browser_esm/* default.a.withConfig */.ZP.a.withConfig({
    componentId: "sc-fe88f347-10"
})(_templateObject10());
var ChevronBtn = styled_components_browser_esm/* default.button.withConfig */.ZP.button.withConfig({
    componentId: "sc-fe88f347-11"
})(_templateObject11(), (0,theme/* color */.$_)("white"));
var SubList = styled_components_browser_esm/* default.ul.withConfig */.ZP.ul.withConfig({
    componentId: "sc-fe88f347-12"
})(_templateObject12(), (0,theme/* color */.$_)("white"));
var SubLink = styled_components_browser_esm/* default.a.withConfig */.ZP.a.withConfig({
    componentId: "sc-fe88f347-13"
})(_templateObject13(), (0,theme/* color */.$_)("midnight_200"), (0,theme/* color */.$_)("emerald_500"), (0,theme/* color */.$_)("white"));

;// CONCATENATED MODULE: ./components/marketingSite/blog/categories/CategoryDrawer.tsx










function CategoryDrawer(param) {
    var _categories = param.categories, categories = _categories === void 0 ? [] : _categories, _onSelect = param.onSelect, onSelect = _onSelect === void 0 ? function() {
        return null;
    } : _onSelect, _onClose = param.onClose, onClose = _onClose === void 0 ? function() {
        return null;
    } : _onClose;
    var t = (0,useI18n/* useI18n */.Q)("blog").t;
    var ref = (0,next_router.useRouter)(), _locale = ref.locale, locale = _locale === void 0 ? "en" : _locale;
    var ref1 = (0,react.useState)(null), openId = ref1[0], setOpenId = ref1[1];
    var blogRoot = "".concat((0,app_urls/* getAppUrl */.TI)(app_urls/* APP_URLS.blog */.uu.blog, locale), "/category");
    var toggle = function(id) {
        return setOpenId(function(p) {
            return p === id ? null : id;
        });
    };
    var goAndClose = function(slug) {
        onSelect(slug);
        onClose();
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Backdrop, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Drawer, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Header, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Title, {
                            children: t("buttons.title")
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(CloseBtn, {
                            onClick: onClose,
                            children: "\xd7"
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(dist/* Button */.zx, {
                    variant: "ghost",
                    schema: "neutral",
                    label: t("buttons.home"),
                    onClick: onClose,
                    startIcon: pro_light_svg_icons/* faHome */.J9Y
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Accordion, {
                    children: categories.map(function(cat) {
                        return /*#__PURE__*/ (0,jsx_runtime.jsxs)(CategoryBlock, {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(CategoryHeader, {
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                            href: "".concat(blogRoot, "/").concat(cat.slug),
                                            passHref: true,
                                            legacyBehavior: true,
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CategoryLink, {
                                                onClick: function() {
                                                    return goAndClose(cat.slug);
                                                },
                                                children: cat.name
                                            })
                                        }),
                                        cat.children.length > 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)(ChevronBtn, {
                                            "aria-label": openId === String(cat.id) ? "Collapse" : "Expand",
                                            onClick: function() {
                                                return toggle(String(cat.id));
                                            },
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(dist/* Icon */.JO, {
                                                icon: openId === String(cat.id) ? pro_solid_svg_icons/* faChevronUp */.mTx : pro_solid_svg_icons/* faChevronDown */.ptq
                                            })
                                        })
                                    ]
                                }),
                                openId === String(cat.id) && /*#__PURE__*/ (0,jsx_runtime.jsx)(SubList, {
                                    children: cat.children.map(function(sub) {
                                        return /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                                href: "".concat(blogRoot, "/").concat(sub.slug),
                                                passHref: true,
                                                legacyBehavior: true,
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(SubLink, {
                                                    onClick: function() {
                                                        return goAndClose(sub.slug);
                                                    },
                                                    children: sub.name
                                                })
                                            })
                                        }, sub.id);
                                    })
                                })
                            ]
                        }, cat.id);
                    })
                })
            ]
        })
    });
}

;// CONCATENATED MODULE: ./components/marketingSite/blog/categories/SubcategoryDropdown.styled.tsx

function SubcategoryDropdown_styled_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  position: relative;\n  display: inline-block;\n  font-family: inherit;\n"
    ]);
    SubcategoryDropdown_styled_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function SubcategoryDropdown_styled_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  align-items: center;\n  gap: 0.35rem;\n  background: transparent;\n  border: none;\n  cursor: pointer;\n  font: inherit;\n  color: inherit;\n  padding: 0;\n"
    ]);
    SubcategoryDropdown_styled_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function SubcategoryDropdown_styled_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  color: ",
        ";\n  width: 0;\n  height: 0;\n  border-left: 6px solid transparent;\n  border-right: 6px solid transparent;\n  border-top: 6px solid currentColor;\n  transition: transform 0.2s ease;\n  transform: ",
        ";\n\n  &:hover {\n    color: ",
        ";\n  }\n"
    ]);
    SubcategoryDropdown_styled_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function SubcategoryDropdown_styled_templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  list-style: none;\n  margin: 0;\n  padding: ",
        " ",
        ";\n  position: absolute;\n  top: calc(100% + 4px);\n  top: 24px;\n  left: 50%;\n  transform: translateX(-90%);\n  background: #ffffff;\n  border: 1px solid #d7dfe7;\n  border-radius: 12px;\n  box-shadow: 0 6px 16px rgba(0, 0, 0, 0.08);\n"
    ]);
    SubcategoryDropdown_styled_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function SubcategoryDropdown_styled_templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: block;\n  padding: ",
        " ",
        ";\n  text-align: center;\n  cursor: pointer;\n  font-size: ",
        ";\n  font-weight: ",
        ";\n  color: ",
        ";\n  background: ",
        ";\n\n  &:hover {\n    background-color: ",
        ";\n    color: white;\n  }\n"
    ]);
    SubcategoryDropdown_styled_templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}


var Wrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-68657105-0"
})(SubcategoryDropdown_styled_templateObject());
var StyledTrigger = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-68657105-1"
})(SubcategoryDropdown_styled_templateObject1());
var Chevron = styled_components_browser_esm/* default.span.withConfig */.ZP.span.withConfig({
    componentId: "sc-68657105-2"
})(SubcategoryDropdown_styled_templateObject2(), function(param) {
    var $isActive = param.$isActive;
    return $isActive ? (0,theme/* color */.$_)("emerald_500") : (0,theme/* color */.$_)("midnight_500");
}, function(param) {
    var $isOpen = param.$isOpen;
    return $isOpen ? "rotate(180deg)" : "none";
}, (0,theme/* color */.$_)("midnight_300"));
var Menu = styled_components_browser_esm/* default.ul.withConfig */.ZP.ul.withConfig({
    componentId: "sc-68657105-3"
})(SubcategoryDropdown_styled_templateObject3(), (0,theme/* spacing */.W0)("xs"), (0,theme/* spacing */.W0)("sm"));
var MenuItem = styled_components_browser_esm/* default.li.withConfig */.ZP.li.withConfig({
    componentId: "sc-68657105-4"
})(SubcategoryDropdown_styled_templateObject4(), (0,theme/* spacing */.W0)("xs"), (0,theme/* spacing */.W0)("xs"), (0,theme/* fontSize */.JB)("md"), (0,theme/* fontWeight */.Ue)("medium"), function(param) {
    var $selected = param.$selected;
    return $selected ? "#ffffff" : "#273043";
}, function(param) {
    var $selected = param.$selected;
    return $selected ? "".concat((0,theme/* color */.$_)("emerald_500")) : "transparent";
}, (0,theme/* color */.$_)("emerald_500"));

;// CONCATENATED MODULE: ./components/marketingSite/blog/categories/SubcategoryDropdown.tsx





function SubcategoryDropdown(param) {
    var locale = param.locale, items = param.items, _isActive = param.isActive, isActive = _isActive === void 0 ? false : _isActive, isOpen = param.isOpen;
    var wrapperRef = (0,react.useRef)(null);
    var router = (0,next_router.useRouter)();
    var getHref = function(slug) {
        return "".concat((0,app_urls/* getAppUrl */.TI)(app_urls/* APP_URLS.blog */.uu.blog, locale), "/category/").concat(slug);
    };
    var handleSelect = function(slug) {
        router.push(getHref(slug));
    };
    var handleKeyPress = function(e, slug) {
        if (e.key === "Enter" || e.key === " ") {
            e.preventDefault();
            handleSelect(slug);
        }
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Wrapper, {
        ref: wrapperRef,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledTrigger, {
                "aria-haspopup": "listbox",
                "aria-expanded": isOpen,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Chevron, {
                    $isOpen: isOpen,
                    $isActive: isActive
                })
            }),
            isOpen && /*#__PURE__*/ (0,jsx_runtime.jsx)(Menu, {
                role: "listbox",
                children: items.map(function(cat) {
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(MenuItem, {
                        role: "option",
                        as: "a",
                        href: getHref(cat.slug),
                        onClick: function() {
                            return handleSelect(cat.slug);
                        },
                        onKeyPress: function(e) {
                            return handleKeyPress(e, cat.slug);
                        },
                        children: cat.name
                    }, cat.id);
                })
            })
        ]
    });
}
{
/* <Link
                key={cat.id}
                href={`${getAppUrl(APP_URLS.blog, locale)}/category/${
                  cat.slug
                }`}
                passHref
              ></Link> */ }
;// CONCATENATED MODULE: ./components/marketingSite/blog/categories/BlogCategoryFilter.tsx
"use client";

















var _obj;
var categoryIconMap = (_obj = {}, (0,_define_property/* default */.Z)(_obj, "B\xfasqueda de empleo", {
    type: "icon",
    iconMenu: pro_light_svg_icons/* faTelescope */.YZW,
    iconTag: pro_solid_svg_icons/* faTelescope */.YZW
}), (0,_define_property/* default */.Z)(_obj, "Crecimiento laboral", {
    type: "icon",
    iconMenu: pro_light_svg_icons/* faChartLine */.Stf,
    iconTag: pro_solid_svg_icons/* faChartLine */.Stf
}), (0,_define_property/* default */.Z)(_obj, "Cultura laboral", {
    type: "icon",
    iconMenu: pro_light_svg_icons/* faCogs */.Kb6,
    iconTag: pro_solid_svg_icons/* faCogs */.Kb6
}), (0,_define_property/* default */.Z)(_obj, "Para empresas", {
    type: "icon",
    iconMenu: pro_light_svg_icons/* faBuilding */.P88,
    iconTag: pro_solid_svg_icons/* faBuilding */.P88
}), (0,_define_property/* default */.Z)(_obj, "Equipo", {
    type: "icon",
    iconMenu: pro_light_svg_icons/* faPeopleGroup */.iOm,
    iconTag: pro_solid_svg_icons/* faPeopleGroup */.iOm
}), (0,_define_property/* default */.Z)(_obj, "Manfred", {
    type: "img",
    imgSrc: (0,paths/* getPublicPath */.A)("/images/blog/manfred-icon-small.svg")
}), (0,_define_property/* default */.Z)(_obj, "Recursos", {
    type: "icon",
    iconMenu: pro_light_svg_icons/* faBook */.FL8,
    iconTag: pro_solid_svg_icons/* faBook */.FL8
}), (0,_define_property/* default */.Z)(_obj, "Career growth", {
    type: "icon",
    iconMenu: pro_light_svg_icons/* faChartLine */.Stf,
    iconTag: pro_solid_svg_icons/* faChartLine */.Stf
}), (0,_define_property/* default */.Z)(_obj, "For companies", {
    type: "icon",
    iconMenu: pro_light_svg_icons/* faBuilding */.P88,
    iconTag: pro_solid_svg_icons/* faBuilding */.P88
}), (0,_define_property/* default */.Z)(_obj, "Job Search", {
    type: "icon",
    iconMenu: pro_light_svg_icons/* faTelescope */.YZW,
    iconTag: pro_solid_svg_icons/* faTelescope */.YZW
}), (0,_define_property/* default */.Z)(_obj, "Work culture", {
    type: "icon",
    iconMenu: pro_light_svg_icons/* faCogs */.Kb6,
    iconTag: pro_solid_svg_icons/* faCogs */.Kb6
}), (0,_define_property/* default */.Z)(_obj, "Resources", {
    type: "icon",
    iconMenu: pro_light_svg_icons/* faBook */.FL8,
    iconTag: pro_solid_svg_icons/* faBook */.FL8
}), (0,_define_property/* default */.Z)(_obj, "Product", {
    type: "icon",
    iconMenu: pro_light_svg_icons/* faCubesStacked */.CAH,
    iconTag: pro_solid_svg_icons/* faCubesStacked */.CAH
}), (0,_define_property/* default */.Z)(_obj, "Team", {
    type: "icon",
    iconMenu: pro_light_svg_icons/* faPeopleGroup */.iOm,
    iconTag: pro_solid_svg_icons/* faPeopleGroup */.iOm
}), (0,_define_property/* default */.Z)(_obj, "Tech community", {
    type: "icon",
    iconMenu: pro_light_svg_icons/* faNetworkWired */.kXW,
    iconTag: pro_solid_svg_icons/* faNetworkWired */.kXW
}), (0,_define_property/* default */.Z)(_obj, "WeAreAtWar", {
    type: "icon",
    iconMenu: pro_light_svg_icons/* faFlag */.RrC,
    iconTag: pro_solid_svg_icons/* faFlag */.RrC
}), _obj);
var BlogCategoryFilter = function(param) {
    var category = param.category, sortedCategories = param.sortedCategories;
    var t = (0,useI18n/* useI18n */.Q)("blog").t;
    var locale = (0,next_router.useRouter)().locale;
    var ref = (0,_sliced_to_array/* default */.Z)(react.useState(false), 2), isDrawerOpen = ref[0], setIsDrawerOpen = ref[1];
    var ref1 = (0,_sliced_to_array/* default */.Z)(react.useState(null), 2), openDropdown = ref1[0], setOpenDropdown = ref1[1];
    var parentCategoriesWithChildren = react.useMemo(function() {
        return sortedCategories.parent.map(function(parent) {
            return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, parent), {
                children: sortedCategories.children.filter(function(cat) {
                    return cat.parent === parent.id && cat.count > 0;
                })
            });
        });
    }, [
        sortedCategories
    ]);
    var AllTab = /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledTabElement, {
        active: !category,
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(TabLink, {
            active: !category,
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(dist/* Icon */.JO, {
                    icon: pro_light_svg_icons/* faHome */.J9Y,
                    size: "l"
                }),
                t("buttons.home")
            ]
        })
    });
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(CategorySection, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(BlogCategoryFilter_styled_StyledTags, {
                children: [
                    category ? /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                        href: (0,app_urls/* getAppUrl */.TI)(app_urls/* APP_URLS.blog */.uu.blog, locale),
                        passHref: true,
                        children: AllTab
                    }) : AllTab,
                    parentCategoriesWithChildren.map(function(cat) {
                        var isActive = category === cat.slug;
                        var iconEntry = categoryIconMap[cat.name];
                        var isIcon = (iconEntry === null || iconEntry === void 0 ? void 0 : iconEntry.type) === "icon";
                        var icon = isIcon ? iconEntry === null || iconEntry === void 0 ? void 0 : iconEntry.iconMenu : undefined;
                        var img = !isIcon ? iconEntry === null || iconEntry === void 0 ? void 0 : iconEntry.imgSrc : undefined;
                        var hasChildren = cat.children && cat.children.length > 0;
                        return /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledTabElement, {
                            active: isActive,
                            onMouseEnter: function() {
                                hasChildren && setOpenDropdown(cat.slug);
                            },
                            onMouseLeave: function() {
                                return hasChildren && setOpenDropdown(null);
                            },
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                    href: "".concat((0,app_urls/* getAppUrl */.TI)(app_urls/* APP_URLS.blog */.uu.blog, locale), "/category/").concat(cat.slug),
                                    passHref: true,
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(TabLink, {
                                        active: isActive,
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(CategoryIconSlot, {
                                                children: !isIcon ? /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                                    role: "none",
                                                    src: img
                                                }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(dist/* Icon */.JO, {
                                                    icon: icon !== null && icon !== void 0 ? icon : pro_light_svg_icons/* faQuestionCircle */.Fuz,
                                                    size: "l"
                                                })
                                            }),
                                            cat.name.charAt(0).toUpperCase() + cat.name.slice(1)
                                        ]
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(SubcategoryDropdown, {
                                    locale: locale,
                                    isActive: isActive,
                                    items: cat.children,
                                    isOpen: openDropdown === cat.slug
                                })
                            ]
                        }, cat.slug);
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(MobileButton, {
                label: t("buttons.openCategoryDrawer"),
                onClick: function() {
                    return setIsDrawerOpen(true);
                },
                schema: "neutral",
                startIcon: pro_light_svg_icons/* faBars */.xiG
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(dist/* Drawer */.dy, {
                isOpened: isDrawerOpen,
                onClose: function() {
                    return setIsDrawerOpen(false);
                },
                title: "Categor\xedas",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CategoryDrawer, {
                    categories: parentCategoriesWithChildren,
                    onClose: function() {
                        return setIsDrawerOpen(false);
                    }
                })
            })
        ]
    });
};

// EXTERNAL MODULE: ./components/marketingSite/blog/utils/blogUtils.ts
var blogUtils = __webpack_require__(92622);
;// CONCATENATED MODULE: ./components/marketingSite/blog/BlogComponent.tsx












var BlogComponent = function(param) {
    var _posts = param.posts, posts = _posts === void 0 ? [] : _posts, _tags = param.tags, tags = _tags === void 0 ? [] : _tags, _featuredPosts = param.featuredPosts, featuredPosts = _featuredPosts === void 0 ? [] : _featuredPosts, _categories = param.categories, categories = _categories === void 0 ? [] : _categories, category = param.category, totalPosts = param.totalPosts, totalPages = param.totalPages, currentPage = param.currentPage;
    var t = (0,useI18n/* useI18n */.Q)("blog").t;
    var sortedCategories = (0,react.useMemo)(function() {
        return (0,blogUtils/* sortCategories */.iH)(categories);
    }, [
        categories
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Page/* default */.ZP, {
        hasScrollTop: true,
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledBlog, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledBlogHeader, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* Heading1 */.nL, {
                            children: t("blog.title")
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            dangerouslySetInnerHTML: {
                                __html: t("blog.desc")
                            }
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(BlogCategoryFilter, {
                    category: category,
                    sortedCategories: sortedCategories
                }),
                (featuredPosts === null || featuredPosts === void 0 ? void 0 : featuredPosts.length) > 0 ? /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledBlogSpotlightCards, {
                    children: featuredPosts.map(function(post) {
                        return /*#__PURE__*/ (0,jsx_runtime.jsx)(cards_BlogSpotlightCard, {
                            post: post,
                            title: post.title.rendered,
                            url: post.slug,
                            thumb: (0,blogUtils/* getPostThumb */.Mj)(post),
                            date: post.date,
                            excerpt: post.excerpt.rendered,
                            allTags: tags
                        }, post.slug);
                    })
                }) : null,
                /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledBlogCards, {
                    children: posts === null || posts === void 0 ? void 0 : posts.map(function(post) {
                        return /*#__PURE__*/ (0,jsx_runtime.jsx)(BlogCard/* default */.Z, {
                            post: post,
                            title: post.title.rendered,
                            url: post.slug,
                            thumb: (0,blogUtils/* getPostThumb */.Mj)(post),
                            date: post.date,
                            allTags: tags
                        }, post.slug);
                    })
                }),
                totalPages > 1 && /*#__PURE__*/ (0,jsx_runtime.jsx)(layout_BlogPagination, {
                    totalPosts: totalPosts,
                    totalPages: totalPages,
                    currentPage: currentPage,
                    category: category
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(BlogCta/* default */.Z, {})
            ]
        })
    });
};
/* harmony default export */ var blog_BlogComponent = (BlogComponent);


/***/ }),

/***/ 99812:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(92228);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(52322);
/* harmony import */ var _fortawesome_free_solid_svg_icons__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(9725);
/* harmony import */ var _fortawesome_react_fontawesome__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(49929);
/* harmony import */ var components_marketingSite_shared_Cta_styled__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(7425);
/* harmony import */ var components_shared_ButtonLink_styled__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(8536);
/* harmony import */ var components_shared_Typography__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(99655);
/* harmony import */ var context_logged_user_loggeduser_context__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(23357);
/* harmony import */ var hooks_useI18n__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(39105);
/* harmony import */ var next_dist_client_router__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(93642);
/* harmony import */ var next_dist_client_router__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(next_dist_client_router__WEBPACK_IMPORTED_MODULE_8__);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(39097);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_9___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_9__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(2784);
/* harmony import */ var services_service_event_tracking__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(27862);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(40286);
/* harmony import */ var theme__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(90408);
/* harmony import */ var utils_app_urls__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(62177);

function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  background-color: #d3d9f3;\n  padding-top: ",
        ";\n  padding-bottom: ",
        ";\n  padding-left: ",
        ";\n  padding-right: ",
        ";\n\n  width: 100%;\n  height: 100%;\n  object-fit: cover;\n  text-align: left;\n\n  mask-image: url('/images/blog/irregular-box-white.svg');\n  mask-size: 100% 100%;\n  mask-repeat: no-repeat;\n  mask-position: center;\n\n  -webkit-mask-image: url('/images/blog/irregular-box-white.svg');\n  -webkit-mask-size: 100% 100%;\n  -webkit-mask-repeat: no-repeat;\n  -webkit-mask-position: center;\n\n  color: #0a053a;\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  width: max-content;\n  white-space: nowrap;\n  flex: 0 0 auto;\n  margin-top: 0;\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  justify-content: left;\n  max-width: ",
        ";\n  margin-top: ",
        ";\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}















var StyledCtaBorder = (0,styled_components__WEBPACK_IMPORTED_MODULE_14__/* ["default"] */ .ZP)(components_marketingSite_shared_Cta_styled__WEBPACK_IMPORTED_MODULE_3__/* .StyledCta */ .B).withConfig({
    componentId: "sc-113d1833-0"
})(_templateObject(), (0,theme__WEBPACK_IMPORTED_MODULE_12__/* .spacing */ .W0)("xl4"), (0,theme__WEBPACK_IMPORTED_MODULE_12__/* .spacing */ .W0)("xl4"), (0,theme__WEBPACK_IMPORTED_MODULE_12__/* .spacing */ .W0)("xl5"), (0,theme__WEBPACK_IMPORTED_MODULE_12__/* .spacing */ .W0)("xl5"));
var StyledButtonLink = (0,styled_components__WEBPACK_IMPORTED_MODULE_14__/* ["default"] */ .ZP)(components_shared_ButtonLink_styled__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .C).withConfig({
    componentId: "sc-113d1833-1"
})(_templateObject1());
var StyledActionsBorder = (0,styled_components__WEBPACK_IMPORTED_MODULE_14__/* ["default"] */ .ZP)(components_marketingSite_shared_Cta_styled__WEBPACK_IMPORTED_MODULE_3__/* .StyledActions */ .V).withConfig({
    componentId: "sc-113d1833-2"
})(_templateObject2(), (0,theme__WEBPACK_IMPORTED_MODULE_12__/* .container */ .nC)("xs"), (0,theme__WEBPACK_IMPORTED_MODULE_12__/* .spacing */ .W0)("md"));
var BlogCta = function() {
    var t = (0,hooks_useI18n__WEBPACK_IMPORTED_MODULE_7__/* .useI18n */ .Q)("blog").t;
    var locale = (0,next_dist_client_router__WEBPACK_IMPORTED_MODULE_8__.useRouter)().locale;
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_10__.useContext)(context_logged_user_loggeduser_context__WEBPACK_IMPORTED_MODULE_6__/* .LoggedUserContext */ .Vi), user = ref.user, loadingUser = ref.loadingUser;
    if (user || loadingUser) {
        return null;
    }
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(StyledCtaBorder, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(components_shared_Typography__WEBPACK_IMPORTED_MODULE_5__/* .Heading3 */ .aC, {
                children: t("cta.title")
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
                dangerouslySetInnerHTML: {
                    __html: t("cta.desc")
                }
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(StyledActionsBorder, {
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_9___default()), {
                    href: "".concat((0,utils_app_urls__WEBPACK_IMPORTED_MODULE_13__/* .getAppUrl */ .TI)(utils_app_urls__WEBPACK_IMPORTED_MODULE_13__/* .APP_URLS.join */ .uu.join, locale), "?locale=").concat(locale, "&source=footer-blog"),
                    passHref: true,
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(StyledButtonLink, {
                        variant: "blogCompany",
                        sizes: "md",
                        onClick: function(e) {
                            return services_service_event_tracking__WEBPACK_IMPORTED_MODULE_11__/* ["default"].trackExternalLandingCtaClicked */ .Z.trackExternalLandingCtaClicked(e, "".concat((0,utils_app_urls__WEBPACK_IMPORTED_MODULE_13__/* .getAppUrl */ .TI)(utils_app_urls__WEBPACK_IMPORTED_MODULE_13__/* .APP_URLS.join */ .uu.join, locale), "?locale=").concat(locale, "&source=footer-blog"), "footer-blog");
                        },
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_fortawesome_react_fontawesome__WEBPACK_IMPORTED_MODULE_2__/* .FontAwesomeIcon */ .G, {
                                icon: _fortawesome_free_solid_svg_icons__WEBPACK_IMPORTED_MODULE_15__/* .faUserAstronaut */ .KCX
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("span", {
                                children: t("cta.action")
                            })
                        ]
                    })
                })
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (BlogCta);


/***/ }),

/***/ 92622:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Em": function() { return /* binding */ getPostCategoriesId; },
/* harmony export */   "Mj": function() { return /* binding */ getPostThumb; },
/* harmony export */   "iH": function() { return /* binding */ sortCategories; },
/* harmony export */   "s9": function() { return /* binding */ hiddenCategories; }
/* harmony export */ });
function getPostThumb(post) {
    var ref;
    var embedded = (ref = post._embedded) === null || ref === void 0 ? void 0 : ref["wp:featuredmedia"];
    var media = embedded && embedded[0] ? embedded[0] : undefined;
    return media ? media.source_url : undefined;
}
var hiddenCategories = [
    "uncategorized",
    "uncategorised",
    "oculto",
    "sin-categorizar",
    "all",
    "todo-el-blog"
];
function getPostCategoriesId(post, categories) {
    if (!post.categories || !categories) {
        return undefined;
    }
    return post.categories.map(function(catId) {
        var category = categories.find(function(c) {
            return c.id === catId;
        });
        return category ? category.name : "";
    }).filter(Boolean).sort(function(a, b) {
        return a.localeCompare(b);
    });
}
var sortCategories = function(categories) {
    var specialFirst = function(a, b) {
        if (a.id === 304) return -1;
        if (b.id === 304) return 1;
        return a.name.localeCompare(b.name);
    };
    return {
        parent: categories.filter(function(cat) {
            return cat.parent === 0;
        }).sort(specialFirst),
        children: categories.filter(function(cat) {
            return cat.parent !== 0;
        }).sort(function(a, b) {
            return a.name.localeCompare(b.name);
        })
    };
};


/***/ }),

/***/ 73412:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(52322);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(97729);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_head__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(5632);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var next_script__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(45847);
/* harmony import */ var next_script__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(next_script__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var utils_config__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(75339);
/* harmony import */ var _HeadMetadataLangAlternate__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(21646);






var HeadMetadata = function(param) {
    var title = param.title, url = param.url, _desc = param.desc, desc = _desc === void 0 ? "" : _desc, imgUrl = param.imgUrl, path = param.path, _indexable = param.indexable, indexable = _indexable === void 0 ? false : _indexable, _extraMeta = param.extraMeta, extraMeta = _extraMeta === void 0 ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {}) : _extraMeta;
    var locale = (0,next_router__WEBPACK_IMPORTED_MODULE_2__.useRouter)().locale;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)((next_head__WEBPACK_IMPORTED_MODULE_1___default()), {
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("title", {
                        children: title
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        name: "description",
                        content: desc || ""
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        property: "og:title",
                        content: title
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        property: "og:description",
                        content: desc || ""
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        property: "og:image",
                        content: imgUrl || "https://www.getmanfred.com/og-image.jpg"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        name: "twitter:card",
                        content: "summary_large_image"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        name: "twitter:site",
                        content: "@getmanfred"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        name: "twitter:creator",
                        content: "@getmanfred"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        name: "twitter:title",
                        content: title
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        name: "twitter:description",
                        content: desc || ""
                    }),
                    imgUrl && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        name: "twitter:image",
                        content: imgUrl
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        property: "og:type",
                        content: "website"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        property: "og:title",
                        content: title
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        property: "og:description",
                        content: desc || ""
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        property: "og:site_name",
                        content: "Get Manfred"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        property: "og:locale",
                        content: locale
                    }),
                    url && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                                property: "og:url",
                                content: "".concat(utils_config__WEBPACK_IMPORTED_MODULE_4__/* .config.appUrl */ .v.appUrl).concat(url.langs["es"])
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("link", {
                                rel: "canonical",
                                href: "".concat(utils_config__WEBPACK_IMPORTED_MODULE_4__/* .config.appUrl */ .v.appUrl).concat(url.langs["es"])
                            })
                        ]
                    }),
                    indexable && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        name: "robots",
                        content: "index,follow"
                    }),
                    extraMeta
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_script__WEBPACK_IMPORTED_MODULE_3___default()), {
                id: "globalLDMetadata",
                type: "application/ld+json",
                dangerouslySetInnerHTML: {
                    __html: '{\n          "@context": "https://schema.org",\n          "@type": "Organization",\n          "name": "Manfred",\n          "url": "https://www.getmanfred.com/",\n          "logo": "https://www.getmanfred.com/favicon.ico",\n          "description": "Plataforma de empleo para profesionales del sector tecnol\xf3gico.",\n          "sameAs": [\n            "https://twitter.com/getmanfred",\n            "https://www.linkedin.com/company/getmanfred/",\n            "https://github.com/getmanfred>"\n          ],\n          "contactPoint": [\n            {\n              "@type": "ContactPoint",\n              "email": "support@getmanfred.com",\n              "contactType": "customer service",\n              "availableLanguage": ["Spanish", "English"]\n            }\n          ],\n          "founder": {\n            "@type": "Person",\n            "name": "David Bonilla",\n            "url": "https://twitter.com/david_bonilla>"\n          },\n          "foundingDate": "2019",\n          "areaServed": "Worldwide",\n          "address": {\n            "@type": "PostalAddress",\n            "addressCountry": "ES",\n            "addressRegion": "Madrid",\n            "addressLocality": "Madrid"\n          },\n          "offers": {\n            "@type": "Service",\n            "name": "Plataforma de empleo para el sector tech",\n            "description": "Conectamos profesionales tecnol\xf3gicos con empresas mediante un enfoque centrado en la privacidad y la transparencia."\n          }\n        }'
                }
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_HeadMetadataLangAlternate__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
                url: url,
                path: path
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (HeadMetadata);


/***/ }),

/***/ 84110:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "y": function() { return /* reexport safe */ _useFeatureFlag__WEBPACK_IMPORTED_MODULE_0__.y; }
/* harmony export */ });
/* harmony import */ var _useFeatureFlag__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(92552);



/***/ }),

/***/ 92552:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "y": function() { return /* binding */ useFeatureFlag; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(98788);
/* harmony import */ var _swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(22970);
/* harmony import */ var context_logged_user_loggeduser_context__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(23357);
/* harmony import */ var flagsmith_react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(98861);
/* harmony import */ var flagsmith_react__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(flagsmith_react__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(2784);





// Hook.
// -----------------------------------------------------------------------------
var useFeatureFlag = function(feature) {
    // Hooks.
    // ---------------------------------------------------------------------------
    var flags = (0,flagsmith_react__WEBPACK_IMPORTED_MODULE_1__.useFlags)([
        feature
    ]);
    var flagsmith = (0,flagsmith_react__WEBPACK_IMPORTED_MODULE_1__.useFlagsmith)();
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(!flagsmith.identity), isLoading = ref[0], setIsLoading = ref[1];
    // TODO: We should work with a Manfredite domain object her at some point
    var user = (0,react__WEBPACK_IMPORTED_MODULE_2__.useContext)(context_logged_user_loggeduser_context__WEBPACK_IMPORTED_MODULE_0__/* .LoggedUserContext */ .Vi).user;
    // Functions.
    // ---------------------------------------------------------------------------
    var identify = (0,react__WEBPACK_IMPORTED_MODULE_2__.useCallback)(/*#__PURE__*/ (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(function() {
        var email;
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_4__.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    if (!(flagsmith.initialised && !flagsmith.identity && user && user.email)) return [
                        3,
                        2
                    ];
                    email = user.email;
                    return [
                        4,
                        flagsmith.identify(email, {
                            email: email,
                            manfrediteId: user.id || null
                        })
                    ];
                case 1:
                    _state.sent();
                    _state.label = 2;
                case 2:
                    return [
                        2
                    ];
            }
        });
    }), [
        flagsmith,
        user
    ]);
    // Effects.
    // ---------------------------------------------------------------------------
    (0,react__WEBPACK_IMPORTED_MODULE_2__.useEffect)(function() {
        identify();
    }, [
        identify
    ]);
    (0,react__WEBPACK_IMPORTED_MODULE_2__.useEffect)(function() {
        if (flagsmith.initialised) {
            setIsLoading(false);
        }
    }, [
        flagsmith.identity,
        flagsmith.initialised
    ]);
    // Return
    // ---------------------------------------------------------------------------
    return {
        isEnabled: flags[feature].enabled,
        isLoading: isLoading,
        getAllTraits: flagsmith.getAllTraits,
        getTrait: flagsmith.getTrait,
        setTrait: flagsmith.setTrait
    };
};


/***/ }),

/***/ 56002:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "N": function() { return /* reexport */ usePageTrack; }
});

// EXTERNAL MODULE: ./context/logged-user/loggeduser.context.tsx
var loggeduser_context = __webpack_require__(23357);
// EXTERNAL MODULE: ./hooks/useFeatureFlag/index.ts
var useFeatureFlag = __webpack_require__(84110);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ./services/service.event-tracking.ts + 1 modules
var service_event_tracking = __webpack_require__(27862);
;// CONCATENATED MODULE: ./hooks/usePageTrack/usePageTrack.ts




var usePageTrack = function(event) {
    var ref = (0,react.useContext)(loggeduser_context/* LoggedUserContext */.Vi), user = ref.user, loadingUser = ref.loadingUser;
    var ref1 = (0,useFeatureFlag/* useFeatureFlag */.y)("talent_manfredite_profile_page_tracking"), isEnabled = ref1.isEnabled, isLoadingFeatureFlag = ref1.isLoading;
    var alreadySent = (0,react.useRef)(false);
    (0,react.useEffect)(function() {
        // Still loading feature flag values
        if (isLoadingFeatureFlag) {
            return;
        }
        // If event is "Public Profile - Page Loaded" and feature flag is disabled, do not track
        var isPublicProfileTrackDisabled = !isLoadingFeatureFlag && !isEnabled && event === "Public Profile - Page Loaded";
        if (isPublicProfileTrackDisabled) {
            return;
        }
        // When user info (if any) is already loaded and event is not tracked yet => Track it
        if (!alreadySent.current) {
            var urlParams = new URLSearchParams(window.location.search);
            // Identify user with campaign traits if user is logged in and campaign exists
            if (urlParams.get("utm_campaign")) {
                identifyUserWithCampaign(urlParams);
            }
            service_event_tracking/* default.page */.Z.page(event, {
                userId: (user === null || user === void 0 ? void 0 : user.id) ? "userId-".concat(user.id) : undefined
            });
            alreadySent.current = true;
        }
    }, [
        loadingUser,
        event,
        user === null || user === void 0 ? void 0 : user.id,
        isLoadingFeatureFlag,
        isEnabled
    ]);
};
function identifyUserWithCampaign(urlParams) {
    var ref, ref1, ref2, ref3, ref4, ref5;
    service_event_tracking/* default.identifyAnonymous */.Z.identifyAnonymous({
        "campaign.name": ((ref = urlParams.get("utm_campaign")) === null || ref === void 0 ? void 0 : ref.toLowerCase()) || undefined,
        "campaign.source": ((ref1 = urlParams.get("utm_source")) === null || ref1 === void 0 ? void 0 : ref1.toLowerCase()) || undefined,
        "campaign.medium": ((ref2 = urlParams.get("utm_medium")) === null || ref2 === void 0 ? void 0 : ref2.toLowerCase()) || undefined,
        "campaign.term": ((ref3 = urlParams.get("utm_term")) === null || ref3 === void 0 ? void 0 : ref3.toLowerCase()) || undefined,
        "campaign.content": ((ref4 = urlParams.get("utm_content")) === null || ref4 === void 0 ? void 0 : ref4.toLowerCase()) || undefined,
        "campaign.id": ((ref5 = urlParams.get("utm_id")) === null || ref5 === void 0 ? void 0 : ref5.toLowerCase()) || undefined
    });
}

;// CONCATENATED MODULE: ./hooks/usePageTrack/index.ts



/***/ }),

/***/ 63201:
/***/ (function() {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ 81192:
/***/ (function() {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ 25237:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

module.exports = __webpack_require__(95805)


/***/ })

}]);